<div class="dialog-container">
  <rt-dialog-body class="body" variant="white no-padding">
    <div class="media-container">
      @if (videoUrl) {
        <div class="video-container">
          <iframe class="step-video" [src]="videoUrl" type="text/html" allowFullScreen> </iframe>
        </div>
      } @else if (imageUrl) {
        <img [src]="imageUrl | ngrxPush" />
      }
    </div>
    <div class="text-container">
      <rt-heading class="headline" variant="large-xx heading">{{ heading }}</rt-heading>
      <div class="description">{{ description }}</div>
    </div>
  </rt-dialog-body>
  <rt-walkthrough-dialog-footer
    [currentStep]="currentStep"
    [stepsTotal]="stepsTotal"
    [ctaText]="ctaText"
    [ctaIcon]="ctaIcon"
    [ofText]="ofText"
    [closeText]="closeText"
    [closeIcon]="closeIcon"
    [displayCtaOnly]="displayCtaOnly"
    [learnMoreText]="learnMoreText"
    [dialogHelpArticle]="dialogHelpArticle"
    (cancel)="cancel.emit()"
    (start)="handleCtaClicked()"
  >
  </rt-walkthrough-dialog-footer>
</div>

@if (showCloseButton) {
  <div class="dialog-close">
    <rt-dialog-close [closeTooltip]="dialogConfig.closeTooltip" (click)="close()"></rt-dialog-close>
  </div>
}
